<template>
  <require from="framework/value_converters/date-and-time"></require>
  <require from="framework/html_behaviors/af-measure"></require>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="controls/bs-form-input"></require>

  <div class="row">
    <div class="col">
      <div class="form-group">
        <bs-form-input type="text" label="Name" placeholder="Zone unique name" value.bind="model.name & validate" disabled.bind="!model.isActive" maxlength="500"></bs-form-input>
      </div>
    </div>
  </div>
  <div class="row" af-measure.bind="[{ property: 'scrollWidth', to: 460, class: 'row-cols-1' }]">
    <div class="col form-group">
      <small><span class="detail-form-label">Created by:</span><span class="detail-form-field">${model.createdBy.fullName}</span></small>
      <small><span class="detail-form-label">Created on:</span><span class="detail-form-field">${model.createdOn | dateTime}</span></small>
    </div>
    <div class="col form-group">
      <small><span class="detail-form-label">Modified by:</span><span class="detail-form-field">${model.modifiedBy.fullName}</span></small>
      <small><span class="detail-form-label">Modified on:</span><span class="detail-form-field">${model.modifiedOn | dateTime}</span></small>
      <small if.bind="!model.isActive"><span class="detail-form-label">Archived by:</span><span class="detail-form-field">${model.archivedBy.fullName}</span></small>
      <small if.bind="!model.isActive"><span class="detail-form-label">Archived on:</span><span class="detail-form-field">${model.archivedOn | dateTime}</span></small>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="sc-buttons-container text-nowrap" style="text-align: right; margin-left: auto;">
        <button type="submit" class="btn btn-primary" af-mutex-click.call="submit()" if.bind="submitButtonVisible">
          <i class="fas fa-paper-plane"></i> Save Changes
        </button>
        <button type="button" class="btn btn-light" af-mutex-click.call="cancel()" if.bind="cancelButtonVisible">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>
